import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { DeleteConfirmationModal } from "@components";
import { TableColumn } from "./TableColumn";

import { AprType } from "@type/HRM/apr";

interface AprTableProps {
  reportsData: AprType[];
  deleteAPR: (e: number) => void;
}

export const AprTable = ({ reportsData, deleteAPR }: AprTableProps) => {
  const { t } = useTranslation();

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [itemID, setItemID] = useState<number>();

  const closeConfirmationModal = () => setIsConfirmationModalOpen(false);

  const deleteAction = () => {
    deleteAPR(itemID as number);
    closeConfirmationModal();
  };

  return (
    <div className="mb-9 py-10">
      {isConfirmationModalOpen && (
        <DeleteConfirmationModal
          isModalOpen={isConfirmationModalOpen}
          action={deleteAction}
          onClose={closeConfirmationModal}
        />
      )}
      <Table
        columns={TableColumn(t, setIsConfirmationModalOpen, setItemID)}
        rows={reportsData}
        // actions={[
        //   {
        //     customIcon: <IconTrash01 size="20" fill="danger" />,
        //     onClick: (id) => {
        //       setIsConfirmationModalOpen(true);
        //       setItemID(id as number);
        //     },
        //   },
        // ]}
      />
    </div>
  );
};
